import { render, staticRenderFns } from "./VideoSound.vue?vue&type=template&id=9c4482dc&scoped=true"
import script from "./VideoSound.vue?vue&type=script&lang=js"
export * from "./VideoSound.vue?vue&type=script&lang=js"
import style0 from "./VideoSound.vue?vue&type=style&index=0&id=9c4482dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4482dc",
  null
  
)

export default component.exports